export default __webpack_public_path__ + "static/media/Marianne-Light_Italic.43572203.woff2";